import React from 'react';
import {
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  Typography,
  Button,
} from '@material-ui/core';
import { generalDialogStyles, resourceFormStyle } from '../../css/style';
import customizationLogo from '../../assets/img/customization_logo.svg';
import PropTypes from 'prop-types';

const styles = resourceFormStyle();
const dialogStyles = generalDialogStyles();

const GeneralDialog = props => (
  <Dialog open={!!props.open} onClose={props.closeDialog}>
    <DialogContent style={props.contentContainerStyle || styles.addItemCusDialogContainer}>
      <IconButton style={props.closeIconStyle || styles.itemCusDialogCloseBtn} onClick={props.onClose}>
        <Icon>{props.iconName || 'close'}</Icon>
      </IconButton>
      <img src={customizationLogo} style={props.imageStyle || styles.dialogImage} />
      <Typography style={props.titleStyle || styles.itemCusDialogTitle}>{props.title}</Typography>
      {props.message}
      <div style={dialogStyles.bottomButtonsContainer}>
        {props.buttons || closeButtonOnly(props)}
      </div>
    </DialogContent>
  </Dialog>
);

const closeButtonOnly = props => (
  <Button style={props.buttonStyle || styles.itemCusBtnInDialog} onClick={props.onClose}>
    {props.buttonText || 'CLOSE'}
  </Button>
);

GeneralDialog.propTypes = {
  type: PropTypes.string,
  action: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.any.isRequired,
  contentContainerStyle: PropTypes.object,
  closeIconStyle: PropTypes.object,
  imageStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  buttonStyle: PropTypes.object,
  buttonText: PropTypes.string,
  iconName: PropTypes.string,
  buttons: PropTypes.node,
};

export default GeneralDialog;
